var lorem = {};
module['exports'] = lorem;
lorem.words = require("./words");
lorem.supplemental = require("./supplemental");



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/es_MX/lorem/index.js
 ** module id = 649
 ** module chunks = 0
 **/